// extracted by mini-css-extract-plugin
module.exports = {"content":"BlockedUsers_content__1Qsgk","item":"BlockedUsers_item__3b-b5","loader":"BlockedUsers_loader__1TEx2","empty":"BlockedUsers_empty__1GqCS"};